import { Spinner } from 'reactstrap';
import { useJobInsights } from '../../hooks/useInsights';
import InsightCard from '../insights/InsightCard';
import InsightsLockedTeaser from '../insights/InsightsLockedTeaser';

export default function JobInsightsSection({ jobId }) {
    const { data, isLoading, isRegenerating } = useJobInsights(jobId);

    if (isLoading && !data) {
        return (
            <div className="d-flex justify-content-center py-3 mb-4">
                <Spinner size="sm" />
            </div>
        );
    }

    if (!data) return null;

    if (data.locked) {
        return <InsightsLockedTeaser teaserInsights={data.teaserInsights} />;
    }

    // Render the section even when there are no insights yet, so the regen
    // spinner has somewhere to show and first-time users see a placeholder.
    const insights = data.insights ?? [];
    const generatedFmt = data.generatedAt
        ? new Date(data.generatedAt).toLocaleDateString('en-GB', {
              day: 'numeric', month: 'short', year: 'numeric',
              hour: '2-digit', minute: '2-digit',
          })
        : null;

    return (
        <div className="mb-4">
            <h2 className="fw-semibold fs-5 mb-3">AI Insights</h2>
            {insights.length > 0 ? (
                <div className="row g-3">
                    {insights.map((insight, i) => (
                        <div key={i} className={`col-sm-6 col-lg-${Math.floor(12 / Math.min(insights.length, 4))}`}>
                            <InsightCard {...insight} />
                        </div>
                    ))}
                </div>
            ) : (
                <div className="border rounded p-4 text-center bg-light">
                    <h6 className="mb-2">No insights yet</h6>
                    <p className="text-muted small mb-0">
                        Add expenses or invoices to this job and we'll generate AI insights tailored to it.
                    </p>
                </div>
            )}
            <div className="d-flex align-items-center justify-content-start gap-2 mt-2 small" style={{ minHeight: 18 }}>
                {isRegenerating ? (
                    <>
                        <Spinner size="sm" color="primary" />
                        <span className="text-primary">Refreshing insights&hellip;</span>
                    </>
                ) : generatedFmt ? (
                    <span className="text-muted">Updated {generatedFmt}</span>
                ) : null}
            </div>
        </div>
    );
}
